module.exports = __webpack_public_path__ + "assets/88bf73241342daac30f06202e2a85af7.mp4";